import React from 'react';
import { STYLES } from '@eventbrite/eds-button';

import { CameraGraphic } from '@eventbrite/eds-iconography';

export const PRIMARY_TYPES = STYLES;
export const DEFAULT_GRAPHIC = <CameraGraphic />;
export const DEFAULT_TYPE = 'fill';
export const SECONDARY_DEFAULT_TYPE = 'neutral';
